import { render, staticRenderFns } from "./DetailsCabinet.vue?vue&type=template&id=09b0c2d2&"
import script from "./DetailsCabinet.vue?vue&type=script&lang=js&"
export * from "./DetailsCabinet.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCabinet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports